import React from 'react';

export const formatHighlight = (
  str: string,
  highlighted = '',
  normal = '',
  separator = '*'
) => {
  const components: any[] = [];
  if (!str) {
    return components;
  }
  let isInBetweenSpecialChars = false;
  let sectionText = '';
  let highlightedText = '';
  let normalText = '';
  for (const subStr of str) {
    if (subStr !== separator) {
      if (isInBetweenSpecialChars) {
        highlightedText += subStr;
      } else {
        normalText += subStr;
      }
    } else {
      if (isInBetweenSpecialChars) {
        sectionText = highlightedText;
        components.push(<span className={highlighted}>{sectionText}</span>);
      } else {
        sectionText = normalText;
        components.push(<span className={normal}>{sectionText}</span>);
      }
      isInBetweenSpecialChars = !isInBetweenSpecialChars;
      highlightedText = '';
      normalText = '';
    }
  }
  if (normalText) {
    components.push(<span className={normal}>{normalText}</span>);
  }
  return components;
};

export const isLeftScrollable = (ref: any) => {
  if (ref?.current?.scrollLeft > 0) {
    return true;
  }
  return false;
};

export const isRightScrollable = (ref: any) => {
  if (
    Math.ceil(ref?.current?.scrollLeft + ref?.current?.offsetWidth) <
    ref?.current?.scrollWidth
  ) {
    return true;
  }
  return false;
};
